export default __webpack_public_path__ + "static/media/console-picker.677fbb64.webp";